// Libraries
import React, { FC } from 'react';

// Types
import { ChartStyles, EditStylesFormProps } from '@/types';

// Components
import EditGeneralStylesForm from '@/components/EditForm/WJP/EditGeneralStylesForm';
import EditTicksStylesForm from '@/components/EditForm/WJP/EditTicksStylesForm';
import EditGridStylesForm from '@/components/EditForm/WJP/EditGridStylesForm';
import EditMainChartStylesForm from '@/components/EditForm/WJP/EditMainChartStylesForm';
import EditSubChartsStylesForm from '@/components/EditForm/WJP/EditSubChartsStylesForm';
import { WJP_DEFAULT_STYLES_SCATTER } from '@/utils/const';
import { useForm } from 'react-hook-form';
import { DevTool } from '@hookform/devtools';

const EditForm: FC<EditStylesFormProps> = ({ chartData, onSubmit }) => {
  const { register, handleSubmit, control } = useForm<ChartStyles>({
    defaultValues: WJP_DEFAULT_STYLES_SCATTER,
    shouldUnregister: true,
  });

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <details
          className="py-2 md:max-w-sm bg-white shadow-lg p-6 rounded-lg mb-6 ring-1 ring-gray-200 min-w-[20rem] cursor-pointer"
          open
        >
          <summary className="font-bold">Nota sobre los estilos:</summary>
          Para ver reflejado los cambios de estilos, tienes que dar clic en{' '}
          <em>Aplicar cambios</em>.
        </details>
        <div className="flex flex-row flex-wrap w-full justify-between md:grid gap-4 grid-cols-2 auto-rows-auto">
          <fieldset className="flex flex-col bg-white shadow-lg p-6 rounded-lg my-6 ring-1 ring-gray-200 min-w-[20rem] md:max-w-sm w-full h-fit">
            <legend className="text-xl pb-2 font-bold float-left">
              Agrupación de las gráficas:
            </legend>
            <EditGeneralStylesForm
              register={register}
              chartData={chartData}
              control={control}
            />
            <EditGridStylesForm
              register={register}
              chartData={chartData}
              control={control}
            />
            <EditTicksStylesForm
              register={register}
              chartData={chartData}
              control={control}
            />
          </fieldset>
          <div className="grid auto-cols-fr md:grid-cols-1 grid-rows-2 gap-4">
            <EditMainChartStylesForm
              register={register}
              chartData={chartData}
              control={control}
            />
            <EditSubChartsStylesForm
              register={register}
              chartData={chartData}
              control={control}
            />
          </div>
        </div>
        <button
          type="submit"
          className="my-2 px-4 py-2 rounded-lg w-40 shadow-xl active:shadow-none bg-sky-200 border-4 text-sky-900 border-sky-900 cursor-pointer"
          disabled={chartData.length === 0}
        >
          Aplicar cambios
        </button>
      </form>

      {process.env.NODE_ENV !== 'production' && (
        <DevTool control={control} placement="bottom-right" />
      )}
    </>
  );
};

export default EditForm;
